import { useI18n } from "@wojo/localization";
import { Checkbox, Text, Tooltip } from "@wojo/ui";
import cn from "clsx";
import { useId } from "react";
import styles from "../base-table/BaseTable.module.scss";

export type TravelerNameCheckboxProps = {
    id: string;
    firstName: string;
    lastName: string;
    selectedEmailsMap: Map<string, string>;
    email: string;
    handleEmailCheckboxChange: (
        id: string,
        email: string,
        checked: boolean,
    ) => void;
};

export const TravelerNameCheckbox: React.FC<TravelerNameCheckboxProps> = (
    props,
) => {
    const {
        id,
        firstName,
        lastName,
        selectedEmailsMap,
        email,
        handleEmailCheckboxChange,
    } = props;

    const cellId = useId();
    const travelerWithoutEmailTooltipText =
        useI18n(
            "account",
        ).account.myGroupMembers.travelerWithoutEmailTooltipText.l();

    const lastAndFirstName = (
        <div
            style={{
                display: "flex",
                flexWrap: "wrap",
            }}
        >
            <Text.Body variant="2" emphasis="2">
                {`${lastName},`}&nbsp;
            </Text.Body>
            <Text.Body variant="2">{firstName}</Text.Body>
        </div>
    );

    return (
        <Checkbox
            label={
                email ? (
                    lastAndFirstName
                ) : (
                    <Tooltip
                        content={
                            <Text.Body id={`tooltip-${cellId}-no-email`}>
                                {travelerWithoutEmailTooltipText}
                            </Text.Body>
                        }
                    >
                        {lastAndFirstName}
                    </Tooltip>
                )
            }
            checked={selectedEmailsMap.has(id)}
            wrapperClassName={cn(styles.checkbox, {
                [styles["checkbox--disabled"]]: !email,
            })}
            value={email}
            disabled={!email}
            onChange={(e) =>
                handleEmailCheckboxChange(id, email, e.target.checked)
            }
        />
    );
};
